import React from 'react'
import ExtraProductsWizard from './ExtraProductsWizard'
import ExtraProductsTab from './ExtraProductsTab'

function ExtraProducts(props: {inWizard: boolean; inExtrasPage: boolean}) {
  return props.inWizard ? <ExtraProductsWizard /> : <ExtraProductsTab />
}
export default ExtraProducts
